import Home from "./Home";
import StepOne from "./stepOne";
import StepTwo from "./stepTwo";
import StepThree from "./stepThree";
import StepFour from "./stepFour";
import NoPage from "./NoPage";
import LoginPage from "./login"
import { useSelector } from 'react-redux';
import { useEffect } from "react";
import Cookies from 'universal-cookie';
import { add } from '../slicers/employeeSlicer'
import { change } from '../slicers/selectedStepSlicer';
import { useDispatch } from 'react-redux';
import { set } from '../slicers/keySlicer'
const Layout = () => {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  
  const callKey = useSelector((state) => state.selectedStep.value)
  console.log(callKey) 

  useEffect(() => {
    const token = cookies.get('privateToken')
    if (token) {
      console.log(process.env.REACT_APP_BASEURL);
      let xhr = new XMLHttpRequest(); 
      let url = new URL(`${process.env.REACT_APP_BASEURL}employee/info`);
      xhr.open('GET', url, true)
      xhr.setRequestHeader('authtoken', token)
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.responseType = 'json';
      xhr.send();
      xhr.onload = () => {
          if (xhr.status == 200) {
            console.log("successfully fetched employee data");
            dispatch(add(xhr.response))
            dispatch(set(token))

          } else{
            console.log("Failed to fetch employee data, redirecting to login.");
            dispatch(change(5)); // Redirect to login if fetching failsdispatch(change(5));
          }
      } 

    } else {
      console.log("No private token found.");
      dispatch(change(5));
    }
  }, [callKey]);

  return (
    <>
        {(() => {
              switch (callKey) {
                                  case 0:  return <Home />;
                                  case 1:  return <StepOne />;
                                  case 2:  return <StepTwo />;
                                  case 3:  return <StepThree />;
                                  case 4:  return <StepFour />;
                                  case 5: return <LoginPage />
                                  default: return <NoPage />;
                              }
              
        })()}
    </>
  )
};

export default Layout;